import React from "react";
import { Card, Dropdown, Menu, Tag } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useCurrency } from "../../provider/courtryProvider";
import { useAccess } from "../../provider/AccessProvider";
import config from "../../config";
import { useSelector } from "react-redux";

export default function SubscriptionCard(props) {
  const item = props.item;
  const navigate = useNavigate();
  const currencyFormatter = useCurrency();
  const access = useAccess(["deleteSubscription", "editSubscription"]);
  const shopDetails = useSelector((state) => state.shopDetails);
  const handleDelete = async (subscriptionId) => {
    if (!access.deleteSubscription()) {
      return;
    }

    var res = await fetch(
      `${config.newApiGateway}/subscription/manageSubscription`,
      {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          actionType: "delete",
          subscriptionId: subscriptionId,
          shopId: shopDetails.shopId,
          ...(["Employee", "Outlet"].includes(shopDetails.userType) && {
            parentShopId: shopDetails.ownerShopId,
          }),
        }),
      }
    );

    const response = await res.json();

    if (response.code === "SUCCESS") {
      props.setSubScriptionList((prev) =>
        prev.filter((sub) => sub.billId !== subscriptionId)
      );
      return alert("Subscription deleted successfully");
    }
    if (response.code === "ERROR") {
      return alert(response.message);
    }
  };
  const menu = (data) => {
    return (
      <Menu>
        <Menu.Item
          style={{
            width: "150px",
            textAlign: "center",
          }}
          onClick={() => {
            if (!access.editSubscription()) {
              return;
            }
            navigate("/dashboard/subscription/edit", {
              state: {
                data,
                mode: "edit",
              },
            });
          }}
          key="Edit"
        >
          Edit
        </Menu.Item>
        {/* <Menu.Item
          style={{
            width: "150px",
            textAlign: "center",
          }}
          onClick={() => handleDelete(data.billId)}
          key="Delete"
        >
          Delete
        </Menu.Item> */}
      </Menu>
    );
  };
  return (
    <Card
      style={{
        background: "#FFFFFF",
        borderRadius: "12px",
        width: "250px",
        height: "250px",
        position: "relative",
        boxShadow: "0 20px 27px rgb(0 0 0 / 5%)",
        marginBottom: "20px",
      }}
    >
      <h4
        style={{
          color: "#67748E",
        }}
      >
        {item.subscriptionName}
      </h4>

      {item.mealPrice > 0 && (
        <h5>{currencyFormatter(item.mealPrice)}/Per Meal</h5>
      )}
      <h6
        style={{
          color: "#A8A8A8",
        }}
      >
        Subscription available for{" "}
        {item?.subscriptionDuration === "monthly" && "monthly"}{" "}
        {item?.subscriptionDuration === "weekly" && "weekly"}{" "}
        {item?.subscriptionDuration === "both" && "monthly & weekly"}
      </h6>
      <h6>
        Weekend included{"  "}
        {item.includeWeekends ? (
          <Tag color={"success"}>Yes</Tag>
        ) : (
          <Tag color={"error"}>No</Tag>
        )}
      </h6>
      <div
        style={{
          position: "absolute",
          bottom: "0",
          left: "0",
          background: "#F7F8F8",
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px 24px",
          borderRadius: "0 0 12px 12px",
          textAlign: "right",
        }}
      >
        {/* <h6
          style={{
            margin: "0",
            color: "#6F6F6F",
          }}
        >
          15 Subscribers
        </h6> */}
        <Dropdown
          getPopupContainer={(el) => el.parentNode}
          overlay={menu(item)}
          placement="bottom"
          arrow
        >
          <EllipsisOutlined
            style={{
              fontSize: "2rem",
              color: "#A1A1AA",
              cursor: "pointer",
              marginLeft: "auto",
            }}
          />
        </Dropdown>
      </div>
    </Card>
  );
}
